import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import CommentFormatter from "@/components/functionals/HoverPopoverMessageFormatter.vue";

export default [
  {
    prop: "Id",
    name: "No. de Queja",
    label: "No. de Queja",
    width: 140,
    align: "center",
    sortable: true
  },
  {
    prop: "ClientCode",
    name: "Codigo del Cliente",
    label: "Codigo del Cliente",
    width: 170,
    align: "center",
    sortable: true
  },
  {
    prop: "CustomerName",
    name: "Cliente",
    label: "Cliente",
    width: 230,
    sortable: true,
    formatter: ({ CustomerName }) => CustomerName
  },
  {
    prop: "ComplaintCode",
    name: "Codigo de Queja",
    label: "Codigo de Queja",
    width: 170,
    align: "center",
    sortable: true
  },
  {
    prop: "Comments",
    name: "Comentario",
    label: "Comentario",
    width: 600,
    sortable: false,
    formatter: CommentFormatter
  },
  {
    prop: "Date",
    name: "Fecha",
    label: "Fecha",
    sortable: true,
    width: 200,
    formatter: DatetimeFormatter
  }
];
